import React, { useState } from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import HomeForm from '../Components/HomeContent/HomeForm'
import { getDownloadURL } from 'firebase/storage'
import {
    ref as storageRef,
    uploadBytesResumable,
    listAll,
  } from "firebase/storage";
  import { ref, onValue, get,set,push,update} from "firebase/database";
import { db, storage } from '../firebase.config';
import { addDoc, collection } from 'firebase/firestore';
const HomeProperties = () => {
  
    const [homeImage, setHomeImage] = useState("")
    const [homeName, setHomeName] = useState("")
    const [homeContent, setHomeContent] = useState("")
    const [homeLink, setHomeLink] = useState("")
    const addImage = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
         setHomeImage(downloadURL)
      
         console.log(downloadURL)
       });
     }
   );
   }
   const addHomeCarousel = () =>{
    addDoc(collection(db, "homeProperties"),{
       name: homeName,
       image:homeImage,
       content:homeContent,
       link:homeLink
    })
    setHomeContent("")
    setHomeImage("")
    setHomeName("")
    setHomeLink("")
   }
  return (
    <div className=' bg-gray-200 h-[100vh] overflow-scroll ' >
         <MultiLevelSidebar />
      <HomeForm homeImage={homeImage}
       addHomeCarousel={addHomeCarousel}
        homeName={homeName}
        setHomeName={setHomeName}
        homeContent={homeContent}
        setHomeContent={setHomeContent}
        homeLink={homeLink}
        setHomeLink={setHomeLink}
        setHomeImage={setHomeImage}
          addImage={addImage} />
    </div>
  )
}

export default HomeProperties